import { usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_POPUP_TYPE } from "@elixir/types";
import CreatePackagePopup from "./create-package-popup";
import CurrentTreatmentDrawer from "./current-treatment/current-treatment-drawer";
import EditPackagePopup from "./edit-package-popup";
import StartOrCurrentTreatment from "./start-or-current-treatment";
import StartTreatmentPopup from "./start-treatment-popup";

const PackagesAndTreatmentsPopupsAndDrawers = () => {
  const packagePopupType = usePackageBookingStore(
    (state) => state.packagePopupType
  );

  switch (packagePopupType) {
    case PACKAGE_POPUP_TYPE.START_TREATMENT:
      return <StartTreatmentPopup />;
    case PACKAGE_POPUP_TYPE.CREATE_PACKAGE:
      return <CreatePackagePopup />;
    case PACKAGE_POPUP_TYPE.EDIT_PACKAGE:
      return <EditPackagePopup />;
    case PACKAGE_POPUP_TYPE.CURRENT_TREATMENT:
      return <CurrentTreatmentDrawer />;
    case PACKAGE_POPUP_TYPE.START_OR_CURRENT_TREATMENT:
      return <StartOrCurrentTreatment />;
    default:
      return <></>;
  }
};

export default PackagesAndTreatmentsPopupsAndDrawers;
